(function (root) {
  'use strict';

  var conditionSets = {
    standard: [
      { value: '0', label: 'Maintained / light soil' },
      { value: '15', label: 'Normal daily driver' },
      { value: '35', label: 'Heavy buildup / extra time' }
    ],
    intensive: [
      { value: '0', label: 'Normal daily driver buildup' },
      { value: '30', label: 'Heavy interior / kids / work truck' },
      { value: 'confirm', label: 'Severe interior condition' }
    ]
  };

  var membershipMatrix = {
    monthly: {
      sedan: { perVisit: 109, monthlyApprox: 109 },
      small_suv: { perVisit: 125, monthlyApprox: 125 },
      large_suv: { perVisit: 142, monthlyApprox: 142 }
    },
    biweekly: {
      sedan: { perVisit: 89, monthlyApprox: 178 },
      small_suv: { perVisit: 102, monthlyApprox: 205 },
      large_suv: { perVisit: 116, monthlyApprox: 231 }
    },
    weekly: {
      sedan: { perVisit: 79, monthlyApprox: 316 },
      small_suv: { perVisit: 91, monthlyApprox: 363 },
      large_suv: { perVisit: 103, monthlyApprox: 411 }
    }
  };

  function autoConditionOptions(packageKind) {
    var intensive = packageKind === 'deep-interior' || packageKind === 'full-detail';
    return (intensive ? conditionSets.intensive : conditionSets.standard).map(function (option) {
      return { value: option.value, label: option.label };
    });
  }

  function calculateAutoEstimate(input) {
    if (!input || !Number.isFinite(input.base) || !Number.isFinite(input.vehicleFee) || input.conditionValue === '' || input.conditionValue == null) {
      return { status: 'incomplete', total: null };
    }
    if (input.conditionValue === 'confirm') return { status: 'confirm', total: null };

    var conditionFee = Number(input.conditionValue);
    var addOns = Array.isArray(input.addOns) ? input.addOns : [];
    if (!Number.isFinite(conditionFee) || addOns.some(function (fee) { return !Number.isFinite(fee); })) {
      return { status: 'incomplete', total: null };
    }

    return {
      status: 'ready',
      total: input.base + input.vehicleFee + conditionFee + addOns.reduce(function (sum, fee) { return sum + fee; }, 0)
    };
  }

  function membershipEstimate(vehicleKey, planKey) {
    var entry = membershipMatrix[planKey] && membershipMatrix[planKey][vehicleKey];
    if (!entry) return null;
    return {
      perVisit: entry.perVisit,
      monthlyApprox: entry.monthlyApprox,
      requiresInitialReset: true
    };
  }

  function formatMoney(value) {
    var amount = Number(value);
    if (!Number.isFinite(amount)) return 'Contact us for this custom-size quote';
    return '$' + amount.toLocaleString('en-US', {
      minimumFractionDigits: Number.isInteger(amount) ? 0 : 2,
      maximumFractionDigits: 2
    });
  }

  function validateLinearLength(value) {
    var text = String(value == null ? '' : value).trim();
    var length = Number(text);
    if (!text || !Number.isFinite(length) || length <= 0) {
      return { valid: false, value: null, reason: !text ? 'missing' : 'invalid' };
    }
    return { valid: true, value: length, reason: '' };
  }

  function calculateLinearFootEstimate(input) {
    input = input || {};
    var lengthResult = validateLinearLength(input.length);
    if (!lengthResult.valid) {
      return { status: 'length-invalid', length: null, total: null, lines: [] };
    }

    var length = lengthResult.value;
    var selectedServices = (Array.isArray(input.services) ? input.services : [])
      .map(function (service) {
        return {
          name: String(service && service.name || '').trim(),
          rate: Number(service && service.rate)
        };
      })
      .filter(function (service) {
        return Number.isFinite(service.rate) && service.rate > 0;
      });

    if (!selectedServices.length) {
      return { status: 'no-service', length: length, total: null, lines: [] };
    }

    var total = 0;
    var lines = [];
    for (var index = 0; index < selectedServices.length; index += 1) {
      var service = selectedServices[index];
      var subtotal = length * service.rate;
      if (!Number.isFinite(subtotal) || subtotal <= 0) {
        return { status: 'custom-size', length: length, total: null, lines: [] };
      }
      total += subtotal;
      if (!Number.isFinite(total) || total <= 0) {
        return { status: 'custom-size', length: length, total: null, lines: [] };
      }
      lines.push({
        name: service.name,
        length: length,
        rate: service.rate,
        subtotal: subtotal,
        text: length + ' ft × ' + formatMoney(service.rate) + '/ft = ' + formatMoney(subtotal)
      });
    }

    return {
      status: 'ready',
      length: length,
      total: total,
      lines: lines
    };
  }

  function quoteProgress(service, state) {
    state = state || {};
    if (service === 'auto') {
      if (!state.packageSelected) return { current: 1, total: 4, action: 'Choose your detail package' };
      if (!state.vehicleSelected) return { current: 2, total: 4, action: 'Choose vehicle type' };
      if (!state.conditionSelected) return { current: 3, total: 4, action: 'Choose vehicle condition' };
      return { current: 4, total: 4, action: 'Review your estimate' };
    }
    if (service === 'boat' || service === 'rv') {
      var label = service === 'boat' ? 'boat' : 'RV';
      if (!state.lengthEntered) return { current: 1, total: 4, action: 'Enter ' + label + ' length' };
      if (!state.exteriorSelected) return { current: 2, total: 4, action: 'Choose exterior service' };
      if (!state.interiorSelected) return { current: 3, total: 4, action: 'Choose interior service' };
      return { current: 4, total: 4, action: 'Review your estimate' };
    }
    if (service === 'headlight') {
      return state.levelSelected
        ? { current: 2, total: 2, action: 'Review your estimate' }
        : { current: 1, total: 2, action: 'Choose lens condition' };
    }
    if (service === 'membership') {
      if (!state.vehicleSelected) return { current: 1, total: 3, action: 'Choose vehicle type' };
      if (!state.planSelected) return { current: 2, total: 3, action: 'Choose plan frequency' };
      return { current: 3, total: 3, action: 'Review your estimate' };
    }
    return { current: 1, total: 1, action: 'Choose a service' };
  }

  root.JSQQuoteRules = Object.freeze({
    schemaVersion: 1,
    phoneE164: '+15098678979',
    autoConditionOptions: autoConditionOptions,
    calculateAutoEstimate: calculateAutoEstimate,
    calculateLinearFootEstimate: calculateLinearFootEstimate,
    membershipEstimate: membershipEstimate,
    quoteProgress: quoteProgress,
    validateLinearLength: validateLinearLength
  });
})(typeof window !== 'undefined' ? window : globalThis);
